import { Pipe, PipeTransform } from '@angular/core';
//import { Widget } from '@nrwl/rx-form-builder';
//import { HealthVuUtilService } from '@nrwl/rx-health-vu-utils';

@Pipe({ name: 'widgetInPrintableMode' })
export class WidgetInPrintableModePipe implements PipeTransform {
  constructor() {}

  transform(isPrintableMode: boolean, widget: any) {
    return null;
  }
}
